import { h } from 'preact'
import { tagParser } from '../../js/modules/utilities'
import smallLogo from './small-logo-orange.svg'
import logo from './logo-orange.png'

export const StratMarque = () => {
   const data = {
      title: 'Les bonnes raisons de choisir [color]Orange[/color] ',
      items: [
         {
            icon: 'Medal',
            label: 'N°1 des réseaux mobiles pour la 13ème année consécutive',
         },
         {
            icon: 'hand-shake',
            label: 'Un acteur de confiance pour un monde numérique plus sûr',
         },
         {
            icon: 'Eco-mode',
            label: 'Un objectif à zéro carbone à atteindre pour 2040',
         },
         {
            icon: 'accessibility-vision',
            label: 'Nos experts connectés à nos client pour rendre le numérique accessible à tous',
         },
      ],
   }
   return (
      <div class="strat-marque py-2 bg-dark text-white">
         <div class="container-fluid">
            <div class="d-flex justify-content-between">
               <h2 class="no-signature mr-2" dangerouslySetInnerHTML={{ __html: tagParser(data.title) }}></h2>
               <picture>
                  <source srcset={smallLogo} media="(max-width: 736px)" />
                  <img class="logo" src={logo} alt="" loading="lazy" />
               </picture>
            </div>

            <div class="row">
               <div class="col-12 col-md-10">
                  <ul class="row">
                     {data.items.map(({ icon, label }, index) => (
                        <li class="col-12 col-md-6" key={index}>
                           <p class="label lead mb-1 mb-md-2">
                              <span class={`icon icon-${icon} mr-2`}></span>
                              <span>{label}</span>
                           </p>
                        </li>
                     ))}
                  </ul>
               </div>
            </div>
         </div>
      </div>
   )
}
